import { render, staticRenderFns } from "./RelatedProjectsList.vue?vue&type=template&id=d1a8ee7c&"
import script from "./RelatedProjectsList.vue?vue&type=script&lang=ts&"
export * from "./RelatedProjectsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports